import React, { FC, useEffect, useState } from "react";
import { Page, Spinner } from "src/components/common";
import ClientCourseCard from "./ClientCourseCard";
import { IUserTrainingCourseSummary } from "src/@types/ImpiricaPlatformApi";
import { useApi } from "src/Api/useApi";
import { toast } from "react-toastify";
import styles from "./ClientTrainingPage.module.css";

interface ClientTrainingPageProps {
	history?: any;
	location?: any;
	match?: any;
	children?: any;
}

/* The following component represents the training landing page */
const ClientTrainingPage: FC<ClientTrainingPageProps> = ({
	history,
	location,
	match,
	children,
}) => {
	const { clientTrainingClient } = useApi();

	const [loading, setLoading] = useState<boolean>(true);
	const [courses, setCourses] = React.useState<IUserTrainingCourseSummary[]>(
		[]
	);

	const _loadData = async () => {
		try {
			setLoading(true);
			if (clientTrainingClient) {
				const trainingSummary = await clientTrainingClient.getTrainingCourses();
				const courses = (trainingSummary && trainingSummary.courses) || [];
				setCourses(courses);
			}
		} catch (err) {
			toast.error("Error loading training courses");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (clientTrainingClient) {
			_loadData();
		}
	}, [clientTrainingClient]);

	const _onNavigate = (trainingCourse: IUserTrainingCourseSummary) => {
		history.push({
			pathname: `/client-training/course/${trainingCourse.courseId}`,
		});
	};

	if (loading) {
		return (
			<div className={styles.spinnerContainer}>
				<Spinner className={"spinner-large"} />
			</div>
		);
	} else {
		return (
			<Page title="Impirica Training">
				<div className={styles.clientTrainingPage}>
					<div className={styles.learningHeader}>
						<h1>Impirica Learning</h1>
					</div>
					<div className={styles.coursesContainerWrapper}>
						<div className={styles.coursesContainer}>
							{courses.length === 0 ? (
								<h3 className={styles.noCourses}>No courses found.</h3>
							) : (
								courses.map((course: IUserTrainingCourseSummary) => {
									return (
										<ClientCourseCard
											trainingCourse={course}
											onNavigate={_onNavigate}
											key={course.courseId}
										/>
									);
								})
							)}
						</div>
					</div>
				</div>
			</Page>
		);
	}
};

export default ClientTrainingPage;
